import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import Link from '../common/link';

import styles from './social-media-link-list.module.scss';

const SocialMediaLinkList = ({ items }) => (
  <div styleName="container">
    <ul>
      {items &&
        items.map(({ type, url }) => (
          <li key={`${type}|${url}`}>
            <Link to={url} rel="noopener noreferrer" target="_blank">
              <i className={`fa fa-${type}`} aria-hidden="true" />
            </Link>
          </li>
        ))}
    </ul>
  </div>
);
SocialMediaLinkList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
};
SocialMediaLinkList.defaultProps = {
  items: [],
};

export default CSSModules(SocialMediaLinkList, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/social-media-link-list.jsx